"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Sign Internal OpenAPI
 * Sign Internal OpenAPI spec
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.FieldSaveToJSON = exports.FieldSaveToJSONJoined = exports.FieldSaveFromJSONTyped = exports.FieldSaveFromJSON = exports.instanceOfFieldSave = exports.FieldSaveComponentTypeEnum = exports.attributeTypeMapFieldSave = void 0;
var CheckboxSave_1 = require("./CheckboxSave");
var DateSave_1 = require("./DateSave");
var DropdownSave_1 = require("./DropdownSave");
var HyperlinkSave_1 = require("./HyperlinkSave");
var ImageSave_1 = require("./ImageSave");
var InitialsSave_1 = require("./InitialsSave");
var RadioButtonSave_1 = require("./RadioButtonSave");
var RectangleSave_1 = require("./RectangleSave");
var SignatureSave_1 = require("./SignatureSave");
var TextSave_1 = require("./TextSave");
exports.attributeTypeMapFieldSave = [
    {
        name: "x",
        type: "number",
    },
    {
        name: "y",
        type: "number",
    },
    {
        name: "z",
        type: "number",
    },
    {
        name: "componentType",
        type: "string",
    },
];
/**
 * @export
 */
exports.FieldSaveComponentTypeEnum = {
    Inputcheckmark: "inputcheckmark",
    Inputdate: "inputdate",
    Inputtextbox: "inputtextbox",
    Inputdropdown: "inputdropdown",
    Inputimage: "inputimage",
    Inputinitials: "inputinitials",
    Inputradiobutton: "inputradiobutton",
    Inputrectangle: "inputrectangle",
    Inputsignature: "inputsignature",
    Inputhyperlink: "inputhyperlink",
};
/**
 * Check if a given object implements the FieldSave interface.
 */
function instanceOfFieldSave(value) {
    if (!("x" in value) || value["x"] === undefined)
        return false;
    if (!("y" in value) || value["y"] === undefined)
        return false;
    if (!("z" in value) || value["z"] === undefined)
        return false;
    if (!("componentType" in value) || value["componentType"] === undefined)
        return false;
    return true;
}
exports.instanceOfFieldSave = instanceOfFieldSave;
function FieldSaveFromJSON(json) {
    return FieldSaveFromJSONTyped(json, false);
}
exports.FieldSaveFromJSON = FieldSaveFromJSON;
function FieldSaveFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    if (!ignoreDiscriminator) {
        if (json["componentType"] === "inputcheckmark") {
            return (0, CheckboxSave_1.CheckboxSaveFromJSONTyped)(json, true);
        }
        if (json["componentType"] === "inputdate") {
            return (0, DateSave_1.DateSaveFromJSONTyped)(json, true);
        }
        if (json["componentType"] === "inputdropdown") {
            return (0, DropdownSave_1.DropdownSaveFromJSONTyped)(json, true);
        }
        if (json["componentType"] === "inputhyperlink") {
            return (0, HyperlinkSave_1.HyperlinkSaveFromJSONTyped)(json, true);
        }
        if (json["componentType"] === "inputimage") {
            return (0, ImageSave_1.ImageSaveFromJSONTyped)(json, true);
        }
        if (json["componentType"] === "inputinitials") {
            return (0, InitialsSave_1.InitialsSaveFromJSONTyped)(json, true);
        }
        if (json["componentType"] === "inputradiobutton") {
            return (0, RadioButtonSave_1.RadioButtonSaveFromJSONTyped)(json, true);
        }
        if (json["componentType"] === "inputrectangle") {
            return (0, RectangleSave_1.RectangleSaveFromJSONTyped)(json, true);
        }
        if (json["componentType"] === "inputsignature") {
            return (0, SignatureSave_1.SignatureSaveFromJSONTyped)(json, true);
        }
        if (json["componentType"] === "inputtextbox") {
            return (0, TextSave_1.TextSaveFromJSONTyped)(json, true);
        }
    }
    return {
        x: json["x"],
        y: json["y"],
        z: json["z"],
        componentType: json["componentType"],
    };
}
exports.FieldSaveFromJSONTyped = FieldSaveFromJSONTyped;
function FieldSaveToJSONJoined(value) {
    if (value == null) {
        return value;
    }
    if (value["componentType"] === "inputcheckmark") {
        return (0, CheckboxSave_1.CheckboxSaveToJSON)(value);
    }
    if (value["componentType"] === "inputdate") {
        return (0, DateSave_1.DateSaveToJSON)(value);
    }
    if (value["componentType"] === "inputdropdown") {
        return (0, DropdownSave_1.DropdownSaveToJSON)(value);
    }
    if (value["componentType"] === "inputhyperlink") {
        return (0, HyperlinkSave_1.HyperlinkSaveToJSON)(value);
    }
    if (value["componentType"] === "inputimage") {
        return (0, ImageSave_1.ImageSaveToJSON)(value);
    }
    if (value["componentType"] === "inputinitials") {
        return (0, InitialsSave_1.InitialsSaveToJSON)(value);
    }
    if (value["componentType"] === "inputradiobutton") {
        return (0, RadioButtonSave_1.RadioButtonSaveToJSON)(value);
    }
    if (value["componentType"] === "inputrectangle") {
        return (0, RectangleSave_1.RectangleSaveToJSON)(value);
    }
    if (value["componentType"] === "inputsignature") {
        return (0, SignatureSave_1.SignatureSaveToJSON)(value);
    }
    if (value["componentType"] === "inputtextbox") {
        return (0, TextSave_1.TextSaveToJSON)(value);
    }
}
exports.FieldSaveToJSONJoined = FieldSaveToJSONJoined;
function FieldSaveToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        x: value["x"],
        y: value["y"],
        z: value["z"],
        componentType: value["componentType"],
    };
}
exports.FieldSaveToJSON = FieldSaveToJSON;
